import { Component, Input } from '@angular/core';
import { InventoryValidationIssue, ValidationStatus } from '../../model/validation-status.model';

@Component({
    selector: 'adm4-inventory-validation-tooltip-content',
    template: `
    @for (validationError of inventoryValidationStatus?._errors; track validationError) {
      <div class='issue-container'>
        <adm4-inventory-validation-issue [issue]='validationError' [isError]='true'></adm4-inventory-validation-issue>
      </div>
    }
    @for (validationWarning of inventoryValidationStatus?._warnings; track validationWarning) {
      <div class='issue-container'>
        <adm4-inventory-validation-issue [issue]='validationWarning' [isWarning]='true'></adm4-inventory-validation-issue>
      </div>
    }
    @for (validationInfo of inventoryValidationStatus?._infos; track validationInfo) {
      <div class='issue-container'>
        <adm4-inventory-validation-issue [issue]='validationInfo' [isInfo]='true'></adm4-inventory-validation-issue>
      </div>
    }
    `,
    styleUrls: ['./inventory-validation-tooltip-content.component.scss'],
    standalone: false
})
export class InventoryValidationTooltipContentComponent {
  @Input() inventoryValidationStatus: ValidationStatus<InventoryValidationIssue> | null;
}
